import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function Loading({ className, text, size }) {
  return (
    <Box>
      <CircularProgress color="inherit" size={size} />
      <h5 className={className}>{text}</h5>
    </Box>
  );
}
